import * as React from "react"
import { SFProIcon, SFProIconProps } from "./SFProIcon"

export interface EyeHiddenIconProps extends Omit<SFProIconProps, 'symbol'> {}

/**
 * Eye hidden icon using SF Pro font symbol (􀋯)
 *
 * This icon represents hidden/private state for visibility toggles.
 *
 * @example
 * ```tsx
 * <EyeHiddenIcon />
 * <EyeHiddenIcon size={16} weight="semibold" />
 * ```
 */
export const EyeHiddenIcon = React.forwardRef<HTMLSpanElement, EyeHiddenIconProps>(
  (props, ref) => {
    return <SFProIcon ref={ref} symbol="􀋯" {...props} />
  }
)

EyeHiddenIcon.displayName = "EyeHiddenIcon"
